import { VipPerson } from "@/types/vipTypes";
import { createSlice } from "@reduxjs/toolkit";

export type Vip = {
  vipMap: VipPerson[];
};

const initialState: Vip = {
  vipMap: [],
};

export const vipSlice = createSlice({
  name: "vip",
  initialState,
  reducers: {
    setVips: (state, action: { payload: VipPerson[] }) => {
      state.vipMap = action.payload;
    },
    addVip: (state, action: { payload: VipPerson }) => {
      state.vipMap.push(action.payload);
    },
    safeAddVip: (state, action: { payload: VipPerson }) => {
      const existingVip = state.vipMap.find((vip) => vip.en_full_name === action.payload.en_full_name);
      if (!existingVip) {
        state.vipMap.push(action.payload);
      }
    },
    clearVips: () => {
      return initialState;
    },
  },
});

export const { setVips, addVip, clearVips, safeAddVip } = vipSlice.actions;
